import React from 'react';
import Paper from '@mui/material/Paper';

var BA_RechtlicheBelehrung = (props) => {
  return (
    <Paper style={{padding:"15px"}}>
        <p>
            Die Bundesartenschutzverordnung schreibt vor, dass Wirbeltiere, die unter die besonders 
            geschützten Arten fallen, unverzüglich anzumelden sind. Unverzüglich bedeutet, dass die 
            Meldung am Tag nach der Anschaffung bzw. nach der Geburt (bzw. sobald die Überlebensfähigkeit 
            des Tieres feststeht) erfolgen muss.<br/>
            Dabei muss neben dem Beginn einer Tierhaltung jedes später zusätzlich hinzukommende Tier der 
            zuständigen Behörde angezeigt werden.
        </p>
    </Paper>
  );
}

export default BA_RechtlicheBelehrung;
